<template>
    <div class="statistic-chart">
        <v-chart v-bind="{ options }" />
        <div class="statistic-chart__label">
            <span> {{ title }} </span>
            <b> {{ count }} </b>
        </div>
    </div>
</template>

<script>
import "echarts";
import VChart from "vue-echarts";

export default {
    components: {
        VChart,
    },
    props: {
        title: { type: String, default: null },
        total: { type: Number, default: 0 },
        count: { type: Number, default: 0 },
    },
    computed: {
        options() {
            return {
                width: 122,
                height: 122,
                series: [
                    {
                        name: "Series 1",
                        type: "pie",
                        radius: "100%",
                        center: ["50%", "50%"],
                        silent: true,
                        labelLine: {
                            show: false,
                        },
                        avoidLabelOverlap: true,
                        data: [
                            {
                                value: this.count,
                            },
                            {
                                value: this.total - this.count,
                            },
                        ],
                    },
                ],
                color: ["#310FA1", "#F7F7F7"],
            };
        },
    },
};
</script>

<style lang="scss" scoped>
.statistic-chart {
    position: relative;
    width: 122px;
    height: 122px;
    &__label {
        position: absolute;
        right: 50%;
        bottom: 50%;
        transform: translateX(50%) translateY(50%);

        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 8px;
        line-height: 1;

        height: 90px;
        width: 90px;
        border-radius: 45px;
        background: white;
    }
}
</style>